import { render } from "./FpSlider.vue?vue&type=template&id=7fcbe356"
import script from "./FpSlider.vue?vue&type=script&lang=js"
export * from "./FpSlider.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__